import React from "react";
import SourceObjectConfiguratorStep from "./SourceObjectConfiguratorStep";

const SourceObjectsStep = (props) => (
  <SourceObjectConfiguratorStep {...props} />
);

export default SourceObjectsStep;
